import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Llevaba 3 años con el mismo vientre hinchado sin importar lo que comiera. En 5 días siguiendo las cenas del protocolo, la presión desapareció. Me desperté el sexto día y noté la diferencia antes incluso de mirarme en el espejo. Mi sueño mejoró completamente.',
    name: 'María G.',
    details: '41 años, Guatemala',
    image: 'https://randomuser.me/api/portraits/women/45.jpg'
  }, {
    quote: 'Soy nutricionista y reconozco cuando algo está basado en ciencia real. Este protocolo aplica principios de cronobiología que yo misma enseño en consulta. Lo recomendaré a mis pacientes.',
    name: 'Dra. Patricia M.',
    details: '38 años, España',
    image: 'https://randomuser.me/api/portraits/women/68.jpg'
  }, {
    quote: 'Probé todo. Jugos detox, ayuno intermitente, dietas sin gluten. Nada funcionaba a largo plazo. Con este método no paso hambre, como comida deliciosa y llevo 3 semanas sin hinchazón. Mi marido nota la diferencia también.',
    name: 'Carmen R.',
    details: '47 años, México',
    image: 'https://randomuser.me/api/portraits/women/52.jpg'
  }, {
    quote: 'Lo que más me sorprendió fue la energía. No esperaba que cambiar la cena mejorara tanto mi nivel de energía por las mañanas. Llevo 2 semanas sin necesitar cafeína hasta las 10 AM.',
    name: 'Lucía V.',
    details: '39 años, Colombia',
    image: 'https://randomuser.me/api/portraits/women/37.jpg'
  }, {
    quote: 'Pensé que era el precio normal de tener más de 40. Que el cuerpo simplemente cambia y ya. Este protocolo me demostró que no. Mi cuerpo puede responder, solo necesitaba la información correcta.',
    name: 'Ana B.',
    details: '44 años, Argentina',
    image: 'https://randomuser.me/api/portraits/women/59.jpg'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream relative" data-id="element-496">
      <div className="max-w-5xl mx-auto" data-id="element-497">
        <div className="text-center mb-16" data-id="element-498">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-499">
            Lo Que Ocurre Cuando Sigues El Protocolo
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-500"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-501">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-white p-8 rounded-2xl shadow-warm border border-forest/5 relative flex flex-col ${index === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1 md:w-1/2 lg:w-full md:mx-auto' : ''}`} data-id="element-502">
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-503" />

              <div className="flex gap-1 mb-6" data-id="element-504">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-gold text-gold" data-id="element-505" />)}
              </div>

              <p className="text-dark/80 italic text-lg mb-8 flex-grow relative z-10" data-id="element-506">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-forest/10" data-id="element-507">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-gold/30" data-id="element-508" />
                <div data-id="element-509">
                  <p className="font-bold text-forest" data-id="element-510">{testimonial.name}</p>
                  <p className="text-sm text-dark/60" data-id="element-511">{testimonial.details}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}